module.exports = __webpack_public_path__ + "assets/media/day21.63287bf1.mp3";